import { parseAuthToken } from './parse-auth-token';
const defaultRefreshRatio = 0.9; // Refresh the token once its past 90% of its lifetime.
/**
 * Determines whether the provided `authToken` should be refreshed.
 */
export const shouldRefreshAuthToken = (authToken) => {
    const { issuedAt, expiresAt } = parseAuthToken(authToken);
    const issuedAtTime = issuedAt.getTime();
    const expiresAtTime = expiresAt.getTime();
    const tokenDurationTime = expiresAtTime - issuedAtTime;
    const refreshAfterTime = Math.floor(tokenDurationTime * defaultRefreshRatio);
    const shouldRefreshTime = issuedAtTime + refreshAfterTime;
    return shouldRefreshTime < Date.now();
};
//# sourceMappingURL=should-refresh-auth-token.js.map